import React from 'react'
import MainLayout from '../../layout/MainLayout'
import TeacherSidebarLayout from '../../layout/teacher/TeacherSidebarLayout'

const StudentsList = () => {
  return (
    
    <MainLayout>
      <TeacherSidebarLayout />
      <div>students list</div>
    </MainLayout>
  )
}

export default StudentsList
